import { Modal, Text, BlockStack } from "@shopify/polaris";

interface Props {
  open: boolean;
  title: string;
  message: string;
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export default function DeleteConfirmationModal({
  open,
  title,
  message,
  destructive = true,
  onConfirm,
  onCancel,
  loading = false,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      primaryAction={{
        content: "Delete",
        destructive,
        onAction: onConfirm,
        loading,
      }}
      secondaryActions={[{ content: "Cancel", onAction: onCancel }]}
    >
      <Modal.Section>
        <BlockStack gap="200">
          <Text as="p">{message}</Text>
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}
